import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule, InputTextareaModule } from 'primeng';
import { ReactiveFormsModule } from '@angular/forms';
import { VmePipesModule } from '../../../../../vme-pipes.module';
import { CarryoverCheckStatus } from '../../../../../enums/carryover-check-status';
import { VmeCommonModule } from '../../../../../vme-common.module';
import { JobScreenCarryOverTask } from '../../../../../interfaces/screen-specific/job-screen';

@Component({
  selector: 'app-carryover-approval-analysis',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    InputTextareaModule,
    ReactiveFormsModule,
    VmePipesModule,
    VmeCommonModule,
  ],
  templateUrl: './carryover-approval-analysis.component.html',
  styleUrls: ['./carryover-approval-analysis.component.css'],
})
export class CarryoverApprovalAnalysisComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  protected readonly CarryoverCheckStatus = CarryoverCheckStatus;
  @Input() carryOverTask!: JobScreenCarryOverTask;
}
